export default {
  path: '/protocol',
  meta: {
    title: '协议',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/protocol`),
}



// WEBPACK FOOTER //
// ./src/views/Protocol/router.js